import {
  Box,
  Image,
  CloseButton,
  Heading,
  Text,
  useTheme,
  Badge,
  Flex,
  Tag,
  Button,
  Link as ChakraLink,
} from "@chakra-ui/react";
import moment from "moment";
import React, { useMemo } from "react";
import { Link, useParams } from "react-router-dom";
import { useOutlet } from "../../data/outlets.api";
import { useFocusOnLngLat } from "../../hooks/useFocusOnLngLat";
import placeholderImg from "../../assets/event-placeholder.jpg";
import DirectionsButton from "../../components/search/DirectionsButton";
import HybridBottomSheetDrawer from "../../components/HybridBottomSheetDrawer";
import QueryStateWrapper from "../../components/QueryStateWrapper";
import OpeningHoursTable from "../../components/outlets/OpeningHoursTable";
import BackButton from "../../components/BackButton";
import FavouriteButton from "../../components/FavouriteButton";

const ViewOutlet = () => {
  const { businessID } = useParams<{ businessID: string }>();
  const { data, isLoading, error, isSuccess } = useOutlet(businessID ?? "");
  const theme = useTheme();

  useFocusOnLngLat(
    data?.longitude ? data?.longitude : undefined,
    data?.latitude ? data?.latitude : undefined,
    useMemo(
      () => ({
        color: data?.isOpen
          ? theme?.colors?.["green"]?.["500"]
          : theme?.colors?.["lancsRed"]?.["300"],
      }),
      [data, theme]
    )
  );

  console.log("Data = ", data);

  return (
    <HybridBottomSheetDrawer>
      <Box>
        <QueryStateWrapper isLoading={isLoading} error={error} data={data}>
          <Image
            src={data?.imageURL}
            objectFit="cover"
            h={48}
            w="full"
            role="img"
            bgSize="cover"
            bgPos={"center"}
          />
          <Box position="relative" p={10}>
            <BackButton />
            <Flex justify="space-between" mb={3}>
              <Box>
                <Heading size="md">
                  {data?.name}{" "}
                  <Badge colorScheme={data?.isOpen ? "green" : "red"}>
                    {data?.isOpen ? "Open" : "Closed"}
                  </Badge>
                </Heading>
              </Box>
              <FavouriteButton name={`${data?.name}`} />
            </Flex>
            {data?.tags && data?.tags.length > 0 ? (
              <Flex flexWrap="wrap" gap={1} my={3}>
                {data?.tags.slice(0, 20).map((t, i) => (
                  <Tag key={i}>{t}</Tag>
                ))}
              </Flex>
            ) : null}
            <Text>{data?.shortDescription}</Text>
            <Box my={6}>
              {data ? (
                <OpeningHoursTable openingHours={data.openingHours} />
              ) : null}
            </Box>
            <Flex flexWrap="wrap" gap={2}>
              {data?.websiteURL ? (
                <Button
                  as={ChakraLink}
                  isExternal
                  href={
                    (!(
                      data.websiteURL.startsWith("https://") ||
                      data.websiteURL.startsWith("http://")
                    )
                      ? "https://"
                      : "") + data.websiteURL
                  }
                >
                  Website
                </Button>
              ) : null}
              {data?.telephone ? (
                <Button as={ChakraLink} href={`tel:${data?.telephone}`}>
                  {data?.telephone}
                </Button>
              ) : null}
              {data?.longitude && data?.latitude && (
                <DirectionsButton lng={data.longitude} lat={data.latitude} />
              )}
            </Flex>
          </Box>
        </QueryStateWrapper>
      </Box>
    </HybridBottomSheetDrawer>
  );
};

export default ViewOutlet;
